import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { PermissionListComponent } from '@adm-web-app/modules/permissions/pages/list/permission-list.component';
import { PermissionEditComponent } from '@adm-web-app/modules/permissions/pages/edit/permission-edit.component';
import { PermissionService } from '@adm-web-app/services/permission.service';
import { PermissionModel } from 'hx-services';

const permissionResolveFn: ResolveFn<PermissionModel> = route => inject(PermissionService).getPermissionById(Number(route.paramMap.get('id')));

export const permissionsRoutes: Routes = [
  {
    path: '', component: PermissionListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: PermissionEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: PermissionEditComponent,
    resolve: {
      permission: permissionResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    },
  },
];
